import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconBarcelonaMinimapMarkers = chakra(
  (props: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={376}
      height={375}
      fill="none"
      viewBox="0 0 376 375"
      aria-hidden="true"
      {...props}
    >
      <g clipPath="url(#icon-barcelona-minimap-markers_svg__a)">
        <path
          fill="url(#icon-barcelona-minimap-markers_svg__b)"
          fillOpacity={0.2}
          stroke="#fff"
          strokeOpacity={0.1}
          strokeWidth={10}
          d="M62.519 234.202c1.712 3.449 5.85 5.649 8.705 5.798l27.276-.094c89.542-.301 229.213-.715 236.006-.501 5.177.164 8.241-.391 10.994-1.69 2.255-1.064 4.302-2.627 7.129-4.702 5.023-3.687 7.04-11.547 7.421-15.016.19-12.785.542-39.635.428-44.749-.143-6.392-2.712-11.298-5.994-14.718-3.567-3.717-8.99-5.649-14.983-7.731-4.453-1.546-9.853-3.165-16.696-5.649-4.432-1.609-9.672-3.669-12.701-4.311-7.705-1.636-12.272 3.122-14.555 6.392-2.283 3.271-4.281 10.556 0 17.246a27.887 27.887 0 0 0 2.451 3.379c2.261 2.664 4.944 4.753 7.5 5.392 0 0 5 1.252 7.5 3.752s9.805 26.874 9.805 26.874c-.269 2.709-2.205 7.226-7.805 3.626s-15.301-9.468-19.451-11.952c-4.138-2.527-75.774-46.979-82.481-50.695-2.684-1.589-5.002-2.752-7.068-3.597-2.218-.907-4.144-1.447-5.918-1.755-3.139-.545-5.993.049-7.563.297-5.175 1.382-8.499 3.466-11.019 5.96-2.901 2.871-4.737 6.286-7.104 9.799-6.945 10.307-20.416 29.854-22.689 34.342-1.158 2.592-1.799 4.72-2.143 6.601-.504 2.758-.368 4.987-.283 7.374.114 3.211-.048 5.996-.143 6.987-1.028 5.352-6.517 7.384-9.133 7.731-3.081.072-9.737.165-17.005.119a485.755 485.755 0 0 1-8.253-.119c-12.557-.297-21.976-5.649-26.257-8.474-2.29-1.512-9.115-6.385-15.164-10.704l-.042-.031c-5.239-3.74-9.884-7.058-10.48-7.403-1.236-.644-4.11-2.408-5.708-4.311-1.598-1.903-1.998-3.667-1.998-4.311-.285-4.906.857-6.282 2.569-8.177 2.283-2.527 5.708-2.825 7.706-2.825 1.159.061 8.293.096 16.627.098 12.191.002 26.949-.07 29.322-.246 3.197-.238 5.994-1.19 6.993-1.636 9.132-3.27 13.175-9.833 14.127-11.596 1.284-2.379 2.283-5.649 2.426-7.582.047-.149.205-2.825-.286-6.095-.713-4.758-4.737-8.217-7.135-9.664-1.492-.9-3.243-1.304-4.659-1.486-1.157-.149-2.091-.149-2.476-.149-.685 0-6.278.099-9.275.149H65.8c-8.418 0-16.326 1.608-21.404 3.568-2.28.879-4.585 1.837-6.896 3.015-5.501 2.805-11.039 6.858-16.364 14.081-7.26 9.848-5.994 20.963-4.424 26.166 1.736 4.993 4.081 8.788 6.788 11.712 2.854 3.083 6.11 5.197 9.48 6.723 3.853 1.586 11.673 4.906 16.125 6.69 2.192.878 4.013 1.81 5.536 2.896 2.342 1.671 3.977 3.706 5.166 6.47 1.856 4.311 1.427 4.757 1.427 8.92 0 1.711-.282 3.273-.116 5.11.122 1.359.49 2.869 1.4 4.702Z"
        />
        <path
          fill="#00FFE8"
          d="m352.629 233.012 1.184 1.613-1.184-1.613Zm-7.982 2.894a2 2 0 0 0 1.706 3.618l-1.706-3.618Zm13.415-18.127c-.172 1.561-.728 4.208-1.831 6.881-1.112 2.696-2.692 5.203-4.785 6.74l2.367 3.225c2.929-2.15 4.869-5.416 6.116-8.439 1.257-3.046 1.899-6.063 2.109-7.971l-3.976-.436Zm-6.616 13.621c-2.902 2.13-4.762 3.545-6.799 4.506l1.706 3.618c2.474-1.167 4.706-2.878 7.46-4.899l-2.367-3.225Z"
        />
        <path
          fill="#FF5252"
          d="m339.501 150.799.656-1.889-.656 1.889Zm14.983 7.731-1.443 1.385 1.443-1.385Zm5.994 14.718 1.999-.045-1.999.045Zm-36.991-29.978a2 2 0 1 0-1.365 3.76l1.365-3.76Zm15.358 9.419c6.113 2.123 11.025 3.922 14.196 7.226l2.886-2.77c-3.964-4.13-9.897-6.195-15.77-8.235l-1.312 3.779Zm14.196 7.226c2.972 3.096 5.307 7.535 5.437 13.378l3.999-.09c-.155-6.943-2.957-12.315-6.55-16.058l-2.886 2.77Zm5.437 13.378c.113 5.065-.238 31.859-.428 44.674l3.999.06c.19-12.756.543-39.661.428-44.824l-3.999.09Zm-36.356-26.263c6.812 2.473 12.419 4.164 16.723 5.659l1.312-3.779c-4.603-1.598-9.796-3.145-16.67-5.64l-1.365 3.76Z"
        />
        <path
          fill="#CCC"
          d="M293.911 146.087a2 2 0 1 0 3.28 2.289l-3.28-2.289Zm16.195-5.248-.415 1.956.415-1.956Zm-12.915 7.537c2.132-3.054 5.999-6.96 12.5-5.581l.831-3.913c-8.911-1.891-14.177 3.718-16.611 7.205l3.28 2.289Zm12.5-5.581c2.848.605 7.861 2.576 12.433 4.235l1.365-3.76c-4.291-1.557-9.758-3.706-12.967-4.388l-.831 3.913Z"
        />
        <path
          fill="#00FF2B"
          d="m295.547 164.477 1.702-1.05-.008-.014-.009-.014-1.685 1.078Zm1.64-16.101a1.998 1.998 0 0 0-.495-2.784 1.998 1.998 0 0 0-2.784.495l3.279 2.289Zm.045 15.023c-3.744-5.851-1.982-12.248-.045-15.023l-3.279-2.289c-2.63 3.766-4.863 11.939-.045 19.468l3.369-2.156Zm2.292 3.163a25.991 25.991 0 0 1-2.275-3.135l-3.404 2.1a29.828 29.828 0 0 0 2.629 3.623l3.05-2.588Z"
        />
        <path
          fill="#FFC107"
          d="M299.525 166.561a2 2 0 0 0-3.05 2.588l3.05-2.588Zm6.46 4.747c-1.965-.491-4.312-2.215-6.46-4.747l-3.05 2.588c2.374 2.798 5.393 5.253 8.54 6.039l.97-3.88Z"
        />
        <path
          fill="#CCC"
          d="M305.986 171.308a2 2 0 0 0-.972 3.88l.972-3.88Zm-.486 1.94-.486 1.94h-.001c-.001 0-.001 0 0 0l.005.001.031.008.138.038a23.974 23.974 0 0 1 2.382.808c1.498.6 3.062 1.416 4.017 2.371l2.828-2.828c-1.545-1.545-3.731-2.605-5.358-3.256a28.151 28.151 0 0 0-2.804-.951 17.513 17.513 0 0 0-.187-.051l-.054-.014-.016-.004-.006-.001-.002-.001h-.001l-.486 1.94Zm6.086 5.166c-.014-.014.063.067.224.334.149.245.326.576.529.997.407.84.877 1.944 1.386 3.24 1.018 2.589 2.152 5.831 3.218 9.023a464.72 464.72 0 0 1 3.63 11.396l.235.774.061.202.015.051.004.013.001.003v.001l1.916-.574 1.915-.575v-.001l-.001-.004-.004-.013-.016-.054-.062-.206-.238-.783a459.058 459.058 0 0 0-3.662-11.497c-1.073-3.215-2.234-6.534-3.289-9.219-.527-1.34-1.038-2.551-1.509-3.522-.429-.884-.943-1.833-1.525-2.414l-2.828 2.828Z"
        />
        <path
          fill="#00FF2B"
          d="m322.805 203.874-1.952-.437-.027.119-.012.12 1.991.198Zm-6.723 1.943a2 2 0 0 0-2.164 3.365l2.164-3.365Zm8.207-4.711-.895-1.789-3.577 1.789.894 1.788 3.578-1.788Zm-3.475 2.57c-.113 1.146-.569 2.318-1.195 2.842-.245.205-.538.335-.992.317-.505-.021-1.333-.238-2.545-1.018l-2.164 3.365c1.588 1.02 3.102 1.589 4.543 1.649 1.493.062 2.751-.431 3.724-1.244 1.808-1.512 2.455-3.953 2.61-5.516l-3.981-.395Zm3.943.634c.153-.687.161-1.946-.468-3.204l-3.578 1.788a1.28 1.28 0 0 1 .132.586c-.002.038-.005.022.01-.043l3.904.873Z"
        />
        <path
          fill="#FFC107"
          d="M296.578 193.832a2 2 0 1 0-2.054 3.432l2.054-3.432Zm19.505 11.986c-5.629-3.62-15.355-9.502-19.505-11.986l-2.054 3.432c4.15 2.484 13.826 8.337 19.396 11.918l2.163-3.364Z"
        />
        <path
          fill="#FF5252"
          d="m213.068 144.853-1.019 1.721.025.014.025.014.969-1.749Zm-6.311-5.448a2 2 0 0 0-1.514 3.703l1.514-3.703Zm5.342 7.197c6.658 3.69 78.198 48.082 82.407 50.653l2.085-3.413c-4.067-2.484-75.799-46.995-82.554-50.739l-1.938 3.499Zm-6.856-3.494c1.957.8 4.187 1.915 6.806 3.466l2.038-3.442c-2.749-1.628-5.156-2.838-7.33-3.727l-1.514 3.703Z"
        />
        <path
          fill="#00FFE8"
          d="m192.519 139.798-.312-1.975-.103.016-.101.027.516 1.932Zm7.563-.297-.342 1.97.342-1.97Zm-19.989 4.836a2 2 0 1 0 2.814 2.843l-2.814-2.843Zm12.738-2.563c1.671-.264 4.164-.779 6.909-.303l.684-3.941c-3.534-.613-6.748.061-8.217.293l.624 3.951Zm6.909-.303c1.619.282 3.407.779 5.503 1.637l1.514-3.703c-2.34-.957-4.405-1.54-6.333-1.875l-.684 3.941Zm-16.833 5.709c2.254-2.231 5.264-4.15 10.128-5.45l-1.032-3.864c-5.485 1.465-9.124 3.714-11.91 6.471l2.814 2.843Z"
        />
        <path
          fill="#FF5252"
          d="m151.708 189.899-1.784-.904-.022.044-.02.045 1.826.815Zm22.69-34.342 1.659 1.117-1.659-1.117Zm-26.799 40.583a1.999 1.999 0 1 0 3.935.719l-3.935-.719Zm5.894-5.337c1.066-2.105 4.909-7.983 9.469-14.778 4.528-6.748 9.602-14.166 13.095-19.351l-3.318-2.235c-3.451 5.123-8.586 12.632-13.098 19.357-4.481 6.677-8.51 12.817-9.717 15.199l3.569 1.808Zm22.564-34.129c2.509-3.724 4.139-6.809 6.852-9.494l-2.814-2.843c-3.089 3.057-5.131 6.8-7.356 10.102l3.318 2.235Zm-24.523 40.185c.311-1.703.899-3.677 2.001-6.145l-3.653-1.63c-1.213 2.716-1.907 4.997-2.283 7.056l3.935.719Z"
        />
        <path
          fill="#CCC"
          d="M147.146 210.67a2 2 0 1 0 3.982.382l-3.982-.382Zm2.133-6.796 1.999-.071-1.999.071Zm1.849 7.178c.103-1.075.268-3.948.15-7.249l-3.997.142c.111 3.121-.048 5.818-.135 6.725l3.982.382Zm.15-7.249c-.086-2.436-.205-4.438.253-6.944l-3.935-.718c-.55 3.011-.398 5.466-.315 7.804l3.997-.142Z"
        />
        <path
          fill="#00FF2B"
          d="M139.741 216.609a2.001 2.001 0 0 0 .526 3.966l-.526-3.966Zm.526 3.966c1.568-.208 3.894-.895 6.01-2.308 2.146-1.433 4.184-3.694 4.824-7.029l-3.929-.754c-.387 2.018-1.607 3.448-3.117 4.456-1.539 1.028-3.266 1.53-4.314 1.669l.526 3.966Z"
        />
        <path
          fill="#FFC107"
          d="M123.013 216.711a2 2 0 1 0-.026 4l.026-4Zm-.026 4c7.29.046 13.965-.047 17.065-.12l-.094-3.999a627.22 627.22 0 0 1-16.945.119l-.026 4Z"
        />
        <path
          fill="#FF5252"
          d="m88.492 210.118 1.102-1.67-1.102 1.67Zm26.257 8.474.047-2-.047 2ZM74.49 197.786a2 2 0 1 0-2.324 3.255l2.324-3.255Zm12.9 14.001c4.424 2.919 14.216 8.494 27.312 8.804l.094-3.999c-12.019-.284-21.064-5.413-25.203-8.144l-2.202 3.339Zm27.312 8.804c2.747.065 5.561.102 8.287.12l.025-4a481.06 481.06 0 0 1-8.218-.119l-.094 3.999Zm-42.536-19.55c6.024 4.302 12.894 9.208 15.225 10.746l2.203-3.339c-2.25-1.485-9.03-6.325-15.104-10.662l-2.324 3.255Z"
        />
        <path
          fill="#CCC"
          d="m62.806 191.98 1.002-1.731-.039-.022-.04-.02-.923 1.773Zm-4.177-5.597a2 2 0 1 0-3.063 2.572l3.063-2.572Zm-3.063 2.572c1.856 2.21 5.013 4.121 6.316 4.799l1.848-3.547c-1.171-.61-3.76-2.228-5.1-3.824l-3.064 2.572Zm6.238 4.756.072.046.22.146c.183.124.426.291.725.499.596.414 1.394.977 2.342 1.649 1.896 1.343 4.374 3.113 7.003 4.99l2.324-3.255c-2.627-1.876-5.111-3.65-7.014-4.999-1.836-1.301-3.266-2.305-3.669-2.538l-2.003 3.462Z"
        />
        <path
          fill="#00FF2B"
          d="M55.098 183.358h2v-.058l-.003-.058-1.997.116Zm.467 5.598a2.001 2.001 0 0 0 3.063-2.573l-3.063 2.573Zm.618-15.116c-.852.944-1.803 2.003-2.414 3.576-.608 1.567-.819 3.458-.667 6.058l3.993-.232c-.134-2.306.084-3.556.403-4.377.316-.815.793-1.391 1.653-2.343l-2.968-2.682Zm-3.085 9.518c0 1.187.616 3.394 2.467 5.598l3.063-2.573c-.656-.781-1.046-1.51-1.27-2.076a4.584 4.584 0 0 1-.218-.698c-.042-.189-.042-.272-.042-.251h-4Z"
        />
        <path
          fill="#FFC107"
          d="m65.374 172.356.104-1.997-.052-.003h-.052v2Zm-9.19 1.484a2 2 0 0 0 2.968 2.682l-2.968-2.682Zm9.19-3.484c-2.075 0-6.292.276-9.19 3.484l2.968 2.682c1.668-1.847 4.3-2.166 6.222-2.166v-4Zm16.627.098c-8.375-.001-15.432-.038-16.523-.095l-.208 3.995c1.226.064 8.438.099 16.73.1l.001-4Z"
        />
        <path
          fill="#FF5252"
          d="m111.322 172.208.149 1.994-.149-1.994ZM82 170.454a2 2 0 0 0 0 4v-4Zm35.499-1.708c-.816.365-3.388 1.249-6.325 1.467l.297 3.989c3.456-.257 6.478-1.276 7.659-1.804l-1.631-3.652Zm-6.325 1.467c-2.276.17-16.92.243-29.174.241v4c12.129.002 27-.068 29.471-.252l-.297-3.989Z"
        />
        <path
          fill="#CCC"
          d="M117.642 168.689a2 2 0 1 0 1.349 3.766l-1.349-3.766Zm13.042-10.663c-.829 1.536-4.556 7.624-13.042 10.663l1.349 3.766c9.779-3.502 14.139-10.54 15.213-12.529l-3.52-1.9Z"
        />
        <path
          fill="#00FF2B"
          d="m134.869 151.394-1.905-.609-.072.226-.018.236 1.995.147Zm-7.42-15.758 1.033-1.713-1.033 1.713Zm7.135 9.663 1.978-.297-1.978.297Zm-11.54-13.134a2 2 0 1 0-.51 3.968l.51-3.968Zm9.83 19.082c-.117 1.597-1.011 4.595-2.191 6.779l3.52 1.901c1.389-2.574 2.493-6.117 2.661-8.385l-3.99-.295Zm-6.458-13.899c2.216 1.337 5.609 4.376 6.19 8.248l3.956-.594c-.847-5.642-5.501-9.523-8.08-11.079l-2.066 3.425Zm6.19 8.248c.229 1.529.307 2.924.322 3.951.008.512-.001.924-.013 1.207a7.967 7.967 0 0 1-.017.302l-.003.028c.001-.004.003-.026.009-.058.002-.012.019-.113.06-.241l3.81 1.218c.067-.21.088-.408.089-.413a11.779 11.779 0 0 0 .049-.665 26.7 26.7 0 0 0 .016-1.437 34.091 34.091 0 0 0-.366-4.486l-3.956.594Zm-10.072-9.463c1.287.165 2.727.519 3.882 1.215l2.066-3.425c-1.83-1.104-3.892-1.559-5.438-1.758l-.51 3.968Z"
        />
        <path
          fill="#FFC107"
          d="M111.037 134.149v2h.017l.016-.001-.033-1.999Zm-5.037-2a2 2 0 1 0 0 4v-4Zm5.07 3.999c3.019-.05 8.579-.148 9.242-.148v-4c-.707 0-6.334.1-9.308.149l.066 3.999Zm9.242-.148c.363 0 1.194 0 2.221.132l.51-3.967c-1.287-.165-2.323-.165-2.731-.165v4Zm-14.312.149H111.037v-4H106v4Z"
        />
        <path
          fill="#00FFE8"
          d="m44.396 137.717.72 1.866-.72-1.866Zm-7.804 1.234a2 2 0 1 0 1.816 3.563l-1.816-3.563Zm8.524.632c4.825-1.862 12.486-3.434 20.685-3.434v-4c-8.64 0-16.794 1.645-22.125 3.702l1.44 3.732Zm20.685-3.434H106v-4H65.801v4Zm-27.393 6.365c2.225-1.134 4.458-2.063 6.708-2.931l-1.44-3.732c-2.31.891-4.686 1.877-7.084 3.1l1.816 3.563Z"
        />
        <path
          fill="#00FFE8"
          d="m16.712 180.979-1.915.578.012.04.014.039 1.89-.657Zm4.424-26.166 1.61 1.187-1.61-1.187Zm.896 39.237a2 2 0 0 0 2.936-2.718l-2.936 2.718Zm-3.405-13.649c-1.469-4.868-2.628-15.25 4.118-24.401l-3.22-2.373c-7.774 10.544-6.398 22.392-4.728 27.93l3.83-1.156ZM22.745 156c5.123-6.947 10.41-10.807 15.663-13.486l-1.816-3.563c-5.748 2.93-11.537 7.177-17.066 14.676l3.22 2.373Zm2.223 35.332c-2.504-2.704-4.713-6.255-6.367-11.01l-3.778 1.314c1.82 5.231 4.3 9.271 7.21 12.414l2.935-2.718Z"
        />
        <path
          fill="#FF5252"
          d="m49.105 206.104-.744 1.856.744-1.856Zm-16.125-6.69-.826 1.822.032.014.032.013.762-1.849Zm-8.012-8.082a2 2 0 0 0-2.936 2.718l2.936-2.718Zm24.88 12.915c-4.448-1.782-12.207-5.078-16.107-6.683l-1.523 3.699c3.807 1.567 11.687 4.912 16.143 6.697l1.488-3.713Zm-16.043-6.655c-3.173-1.437-6.196-3.407-8.837-6.26l-2.936 2.718c3.067 3.313 6.557 5.571 10.122 7.186l1.65-3.644Zm21.997 9.78c-1.693-1.208-3.669-2.209-5.953-3.125l-1.488 3.713c2.1.842 3.767 1.704 5.118 2.668l2.323-3.256Z"
        />
        <path
          fill="#CCC"
          d="m59.807 215.47 1.837-.791-1.837.791Zm-4.005-8.098a1.999 1.999 0 1 0-2.323 3.256l2.323-3.256Zm7.433 17.018c0-1.848.11-3.311-.03-4.617-.157-1.47-.607-2.878-1.56-5.094l-3.675 1.581c.902 2.096 1.165 3.067 1.258 3.938.11 1.036.007 1.877.007 4.192h4Zm-1.59-9.711c-1.33-3.089-3.193-5.417-5.843-7.307l-2.323 3.256c2.036 1.452 3.442 3.193 4.491 5.632l3.675-1.581Zm1.464 14.641c-.069-.768-.047-1.5.001-2.303.046-.766.125-1.692.125-2.627h-4c0 .776-.063 1.487-.118 2.388-.051.865-.088 1.833.009 2.902l3.983-.36Z"
        />
        <path
          fill="#00FF2B"
          d="m62.518 234.202-1.791.889 1.791-.889Zm.591-4.882a2 2 0 0 0-3.984.36l3.984-.36Zm8.218 8.683c-1.018-.053-2.442-.5-3.827-1.362-1.373-.855-2.538-2.014-3.19-3.328l-3.583 1.778c1.06 2.135 2.82 3.801 4.658 4.945 1.826 1.137 3.898 1.866 5.734 1.961l.208-3.994Zm-7.017-4.69c-.803-1.617-1.101-2.886-1.2-3.993l-3.985.36c.146 1.611.584 3.361 1.602 5.411l3.583-1.778Z"
        />
        <path
          fill="#FFC107"
          d="M71.216 238a2 2 0 1 0 .014 4l-.014-4Zm27.276-.094L71.216 238l.014 4 27.276-.094-.014-4Z"
        />
        <path
          fill="#FF5252"
          d="m334.506 239.405-.063 1.999.063-1.999Zm-236.013-1.499a2 2 0 0 0 .014 4l-.014-4Zm246.154-2c-2.363 1.115-5.078 1.658-10.078 1.5l-.126 3.998c5.354.169 8.768-.398 11.91-1.88l-1.706-3.618Zm-10.078 1.5c-6.84-.216-146.576.199-236.076.5l.014 4c89.583-.301 229.189-.715 235.936-.502l.126-3.998Z"
        />
        <g filter="url(#icon-barcelona-minimap-markers_svg__c)">
          <rect
            width={20}
            height={20}
            x={46.5}
            y={244}
            fill="url(#icon-barcelona-minimap-markers_svg__d)"
            rx={10}
          />
          <g filter="url(#icon-barcelona-minimap-markers_svg__e)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m56.327 251.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
            />
          </g>
        </g>
        <g filter="url(#icon-barcelona-minimap-markers_svg__f)">
          <rect
            width={20}
            height={20}
            x={30.5}
            y={214}
            fill="url(#icon-barcelona-minimap-markers_svg__g)"
            rx={10}
          />
          <g filter="url(#icon-barcelona-minimap-markers_svg__h)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m37.505 226.236 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V228h-5.784v-1.764Z"
            />
          </g>
        </g>
        <g filter="url(#icon-barcelona-minimap-markers_svg__i)">
          <rect
            width={20}
            height={20}
            x={24.5}
            y={162}
            fill="url(#icon-barcelona-minimap-markers_svg__j)"
            rx={10}
          />
          <g filter="url(#icon-barcelona-minimap-markers_svg__k)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M31.287 174.764v-1.188h1.392v.768l.468.456h2.28l.468-.456v-1.524l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34L36.05 176h-3.528l-1.236-1.236Z"
            />
          </g>
        </g>
        <g filter="url(#icon-barcelona-minimap-markers_svg__l)">
          <rect
            width={20}
            height={20}
            x={103.5}
            y={141}
            fill="url(#icon-barcelona-minimap-markers_svg__m)"
            rx={10}
          />
          <g filter="url(#icon-barcelona-minimap-markers_svg__n)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M114.207 153.392h-4.08v-1.572l3.684-5.22h1.788v5.592h1.02v1.2h-1.02V155h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
            />
          </g>
        </g>
        <g filter="url(#icon-barcelona-minimap-markers_svg__o)">
          <rect
            width={20}
            height={20}
            x={48.5}
            y={145}
            fill="url(#icon-barcelona-minimap-markers_svg__p)"
            rx={10}
          />
          <g filter="url(#icon-barcelona-minimap-markers_svg__q)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M55.39 157.764v-1.224h1.391v.804l.468.456h2.256l.468-.456v-2.064l-.468-.468H55.51V150.6h5.688v1.2h-4.32v1.812h3.24l1.248 1.248v2.904L60.13 159h-3.504l-1.236-1.236Z"
            />
          </g>
        </g>
        <g filter="url(#icon-barcelona-minimap-markers_svg__r)">
          <rect
            width={20}
            height={20}
            x={83.5}
            y={184}
            fill="url(#icon-barcelona-minimap-markers_svg__s)"
            rx={10}
          />
          <g filter="url(#icon-barcelona-minimap-markers_svg__t)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M90.41 196.764v-5.928l1.236-1.236h3.528l1.235 1.236v1.104h-1.392v-.66l-.48-.48h-2.256l-.48.48v2.256l.793-.78h2.628l1.236 1.236v2.772L95.221 198h-3.576l-1.237-1.236Zm4.175.036.48-.48v-1.884l-.48-.48h-1.8l-.983 1.008v1.356l.48.48h2.303Z"
            />
          </g>
        </g>
        <g filter="url(#icon-barcelona-minimap-markers_svg__u)">
          <rect
            width={20}
            height={20}
            x={159.5}
            y={191}
            fill="url(#icon-barcelona-minimap-markers_svg__v)"
            rx={10}
          />
          <g filter="url(#icon-barcelona-minimap-markers_svg__w)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M166.256 203.764v-2.34l.756-.756-.636-.636v-2.196l1.236-1.236h3.528l1.236 1.236v2.196l-.636.636.756.756v2.34L171.26 205h-3.768l-1.236-1.236Zm4.248-3.612.48-.48v-1.392l-.48-.48h-2.256l-.48.48v1.392l.48.48h2.256Zm.12 3.648.48-.48v-1.524l-.48-.468h-2.496l-.48.468v1.524l.48.48h2.496Z"
            />
          </g>
        </g>
        <g filter="url(#icon-barcelona-minimap-markers_svg__x)">
          <rect
            width={20}
            height={20}
            x={117.5}
            y={190}
            fill="url(#icon-barcelona-minimap-markers_svg__y)"
            rx={10}
          />
          <g filter="url(#icon-barcelona-minimap-markers_svg__z)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M128.661 197.028v-.228h-4.248v-1.2h5.688v1.464L126.753 204h-1.464l3.372-6.972Z"
            />
          </g>
        </g>
        <g filter="url(#icon-barcelona-minimap-markers_svg__A)">
          <rect
            width={20}
            height={20}
            x={186.5}
            y={150}
            fill="url(#icon-barcelona-minimap-markers_svg__B)"
            rx={10}
          />
          <g filter="url(#icon-barcelona-minimap-markers_svg__C)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M193.44 162.764v-1.02h1.392v.576l.48.48h2.184l.48-.48v-2.172l-.744.744h-2.676l-1.236-1.236v-2.82l1.236-1.236h3.576l1.236 1.236v5.928L198.132 164h-3.456l-1.236-1.236Zm3.648-3.072.888-.888v-1.524l-.48-.48h-2.304l-.48.48v1.932l.48.48h1.896Z"
            />
          </g>
        </g>
        <g filter="url(#icon-barcelona-minimap-markers_svg__D)">
          <rect
            width={20}
            height={20}
            x={328.5}
            y={208}
            fill="url(#icon-barcelona-minimap-markers_svg__E)"
            rx={10}
          />
          <g filter="url(#icon-barcelona-minimap-markers_svg__F)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m334.341 215.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.262 5.592v-5.736l1.332-1.332h3.624l1.332 1.332v5.736L342.559 222h-3.624l-1.332-1.332Zm4.308.132.588-.576v-4.848l-.588-.576h-2.328l-.588.576v4.848l.588.576h2.328Z"
            />
          </g>
        </g>
        <g filter="url(#icon-barcelona-minimap-markers_svg__G)">
          <rect
            width={20}
            height={20}
            x={318.5}
            y={159}
            fill="url(#icon-barcelona-minimap-markers_svg__H)"
            rx={10}
          />
          <g filter="url(#icon-barcelona-minimap-markers_svg__I)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m325.958 166.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm4.738 0-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
            />
          </g>
        </g>
        <g filter="url(#icon-barcelona-minimap-markers_svg__J)">
          <rect
            width={20}
            height={20}
            x={265.5}
            y={133}
            fill="url(#icon-barcelona-minimap-markers_svg__K)"
            rx={10}
          />
          <g filter="url(#icon-barcelona-minimap-markers_svg__L)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m271.803 140.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.071 5.16 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V147h-5.784v-1.764Z"
            />
          </g>
        </g>
        <g filter="url(#icon-barcelona-minimap-markers_svg__M)">
          <rect
            width={20}
            height={20}
            x={322.5}
            y={120}
            fill="url(#icon-barcelona-minimap-markers_svg__N)"
            rx={10}
          />
          <g filter="url(#icon-barcelona-minimap-markers_svg__O)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m328.634 127.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.022 5.688v-1.188h1.392v.768l.468.456h2.28l.468-.456v-1.524l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34L336.42 134h-3.528l-1.236-1.236Z"
            />
          </g>
        </g>
        <g filter="url(#icon-barcelona-minimap-markers_svg__P)">
          <rect
            width={20}
            height={20}
            x={342.5}
            y={246}
            fill="url(#icon-barcelona-minimap-markers_svg__Q)"
            rx={10}
          />
          <g filter="url(#icon-barcelona-minimap-markers_svg__R)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m348.774 253.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm6.802 5.316h-4.08v-1.572l3.684-5.22h1.788v5.592h1.02v1.2h-1.02V260h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
            />
          </g>
        </g>
        <path
          fill="#fff"
          fillOpacity={0.95}
          d="M219.017 219.295h3.598v4.526h-3.598zM219.017 228.347h3.598v4.526h-3.598zM219.017 237.398h3.598v4.526h-3.598zM219.017 246.45h3.598v4.526h-3.598zM219.017 255.501h3.598v4.526h-3.598zM222.615 223.821h3.598v4.526h-3.598zM222.615 232.872h3.598v4.526h-3.598zM222.615 241.924h3.598v4.526h-3.598zM222.615 250.976h3.598v4.526h-3.598z"
        />
        <path
          fill="#000"
          d="M222.615 219.295h3.598v4.526h-3.598zM222.615 228.347h3.598v4.526h-3.598zM222.615 237.398h3.598v4.526h-3.598zM222.615 246.45h3.598v4.526h-3.598zM222.615 255.501h3.598v4.526h-3.598zM219.017 223.821h3.598v4.526h-3.598zM219.017 232.872h3.598v4.526h-3.598zM219.017 241.924h3.598v4.526h-3.598zM219.017 250.976h3.598v4.526h-3.598z"
        />
        <path
          fill="#E2645A"
          d="m195.85 265.677 13.239 9.856v-19.761l-13.239 9.905Zm-2.022 0c0-.729.267-1.408.801-1.797l13.888-10.342c1.068-.825 2.403.146 2.403 1.748v20.781c0 1.554-1.335 2.573-2.403 1.796l-13.888-10.39c-.534-.437-.801-1.117-.801-1.796Z"
        />
      </g>
      <defs>
        <filter
          id="icon-barcelona-minimap-markers_svg__c"
          width={36}
          height={36}
          x={38.5}
          y={238}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__e"
          width={19.227}
          height={24.4}
          x={46.491}
          y={243.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__f"
          width={36}
          height={36}
          x={22.5}
          y={208}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__h"
          width={21.831}
          height={24.4}
          x={29.457}
          y={213.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__i"
          width={36}
          height={36}
          x={16.5}
          y={156}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__k"
          width={22}
          height={24.4}
          x={23.287}
          y={161.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__l"
          width={36}
          height={36}
          x={95.5}
          y={135}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__n"
          width={22.492}
          height={24.4}
          x={102.127}
          y={140.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__o"
          width={36}
          height={36}
          x={40.5}
          y={139}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__q"
          width={21.977}
          height={24.4}
          x={47.389}
          y={144.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__r"
          width={36}
          height={36}
          x={75.5}
          y={178}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__t"
          width={22.048}
          height={24.4}
          x={82.409}
          y={183.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__u"
          width={36}
          height={36}
          x={151.5}
          y={185}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__w"
          width={22.24}
          height={24.4}
          x={158.256}
          y={190.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__x"
          width={36}
          height={36}
          x={109.5}
          y={184}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__z"
          width={21.688}
          height={24.4}
          x={116.413}
          y={189.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__A"
          width={36}
          height={36}
          x={178.5}
          y={144}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__C"
          width={22.048}
          height={24.4}
          x={185.32}
          y={149.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__D"
          width={36}
          height={36}
          x={320.5}
          y={202}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__F"
          width={27.386}
          height={24.4}
          x={324.505}
          y={207.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__G"
          width={36}
          height={36}
          x={310.5}
          y={153}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__I"
          width={23.966}
          height={24.4}
          x={316.122}
          y={158.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__J"
          width={36}
          height={36}
          x={257.5}
          y={127}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__L"
          width={26.689}
          height={24.4}
          x={261.968}
          y={132.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__M"
          width={36}
          height={36}
          x={314.5}
          y={114}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__O"
          width={26.858}
          height={24.4}
          x={318.798}
          y={119.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__P"
          width={36}
          height={36}
          x={334.5}
          y={240}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <filter
          id="icon-barcelona-minimap-markers_svg__R"
          width={27.05}
          height={24.4}
          x={338.938}
          y={245.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_37616"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_37616"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_37616"
            result="effect2_dropShadow_9632_37616"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_37616"
            result="shape"
          />
        </filter>
        <linearGradient
          id="icon-barcelona-minimap-markers_svg__b"
          x1={15.5}
          x2={360.5}
          y1={187.515}
          y2={187.515}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4FC5BA" />
          <stop offset={1} stopColor="#4FC5BA" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="icon-barcelona-minimap-markers_svg__d"
          x1={66.5}
          x2={46.5}
          y1={244}
          y2={264}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-barcelona-minimap-markers_svg__g"
          x1={50.5}
          x2={30.5}
          y1={214}
          y2={234}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-barcelona-minimap-markers_svg__j"
          x1={44.5}
          x2={24.5}
          y1={162}
          y2={182}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-barcelona-minimap-markers_svg__m"
          x1={123.5}
          x2={103.5}
          y1={141}
          y2={161}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-barcelona-minimap-markers_svg__p"
          x1={68.5}
          x2={48.5}
          y1={145}
          y2={165}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-barcelona-minimap-markers_svg__s"
          x1={103.5}
          x2={83.5}
          y1={184}
          y2={204}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-barcelona-minimap-markers_svg__v"
          x1={179.5}
          x2={159.5}
          y1={191}
          y2={211}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-barcelona-minimap-markers_svg__y"
          x1={137.5}
          x2={117.5}
          y1={190}
          y2={210}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-barcelona-minimap-markers_svg__B"
          x1={206.5}
          x2={186.5}
          y1={150}
          y2={170}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-barcelona-minimap-markers_svg__E"
          x1={348.5}
          x2={328.5}
          y1={208}
          y2={228}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-barcelona-minimap-markers_svg__H"
          x1={338.5}
          x2={318.5}
          y1={159}
          y2={179}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-barcelona-minimap-markers_svg__K"
          x1={285.5}
          x2={265.5}
          y1={133}
          y2={153}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-barcelona-minimap-markers_svg__N"
          x1={342.5}
          x2={322.5}
          y1={120}
          y2={140}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-barcelona-minimap-markers_svg__Q"
          x1={362.5}
          x2={342.5}
          y1={246}
          y2={266}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <clipPath id="icon-barcelona-minimap-markers_svg__a">
          <path fill="#fff" d="M.5 0h375v375H.5z" />
        </clipPath>
      </defs>
    </svg>
  )
);
export default SvgIconBarcelonaMinimapMarkers;
